import { type ChangeEvent, type ReactNode, useCallback } from 'react'
import cx from 'classnames'
import styles from './FileButton.module.css'

interface FileButtonProps {
  onChange?: (e: FileList) => unknown
  overlay?: boolean
  children?: ReactNode
  accept?: string
  multiple?: boolean
  isDisabled?: boolean
  hover?: boolean
  stretchButton?: boolean
}

/**
 * Wraps any component and overlays a file input.
 */
export function FileButton({
  children,
  onChange,
  overlay,
  multiple,
  hover,
  stretchButton,
  isDisabled,
  ...rest
}: FileButtonProps) {
  const change = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.files) {
        onChange?.(e.target.files)
      }
    },
    [onChange],
  )

  return (
    <div
      className={cx(
        styles.root,
        overlay && styles.fill,
        hover && styles.hover,
        stretchButton && styles.stretchButton,
      )}
    >
      {children}
      <input
        multiple={multiple || false}
        value=""
        disabled={isDisabled}
        {...rest}
        type="file"
        onChange={change}
        className={styles.input}
      />
    </div>
  )
}
